<template>
  <div data-grm-comp="RoomCBTLogInfo">
    <table>
      <colgroup>
        <col width="1">
        <col width="1">
        <col width="1">
        <col width="1">
        <col width="3">
      </colgroup>
      <thead>
      <tr>
        <th>문항 수</th>
        <th>총 점수</th>
        <th>참여 인원</th>
        <th>제한 시간</th>
        <th>출제 기간</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{ cbtLog.cbt.questionCnt }}</td>
        <td>{{ getRoomCBTLogTotalScore() }}</td>
        <td>{{ cbtLog.roomCbtUserLogList.length }}</td>
        <td>{{ duration(cbtLog.duration) }}</td>
        <td>{{ dayjs(cbtLog.beginDate).format('YYYY-MM-DD HH:mm:ss') }} ~ {{ dayjs(cbtLog.endDate).format('YYYY-MM-DD HH:mm:ss') }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import dayjs from "dayjs";

export default {
  name: 'RoomCBTLogInfo',
  computed: {
    ...mapState('cbt', [
      'cbtLog'
    ]),
    ...mapGetters('cbt', [
      'getRoomCBTLogTotalScore',
    ]),

    duration() {
      return duration => {
        const hour = Math.floor(duration / 3600);
        const minute = Math.floor((duration % 3600) / 60);
        const second = duration % 60;
        return `${hour ? hour + this.$t('common.hour') + ' ' : ''}${minute ? minute + this.$t('common.minute') + ' ' : ''}${second ? second + this.$t('common.second') : ''}`;
      }
    }
  },
  methods: {
    dayjs
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  table-layout: fixed;
  border: 1px solid #ccc;
}
thead {
  tr {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
tbody {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  &:first-child {
    border-top: none;
  }
}
tr {
  height: 40px;
  white-space: nowrap;
}
th {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
td {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
</style>